import { useState } from "react";

// ── Data ──────────────────────────────────────────────────────────────────────

// Replace `image` with your real partner logo/photo paths (e.g. "/partners/bcci.png").
// `alt` should describe the partner for accessibility.
const PARTNERS = [
  {
    name: "Praveen",
    image: "images/praveen.jpeg",
    alt: "Board Member of Sporting Goods",
    description:
      "Creating opportunities towards collaborations and partnerships.",
  },
];


function PartnerCard({ partner }) {
  return (
    <div>
      {/* Partner image */}
      <div className="w-full aspect-[16/14] overflow-hidden rounded border border-gray-200 bg-gray-50">
        <img
          src={partner.image}
          alt={partner.alt}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>

      {/* Partner name */}
      <h3 className="text-base font-bold text-black uppercase tracking-wide mt-3 mb-1.5">
        {partner.name}
      </h3>

      {/* Description */}
      <p className="text-sm leading-relaxed text-gray-700">
        {partner.description}
      </p>
    </div>
  );
}

// ── Main Page ──

export default function ProudPartner() {
  return (
    <div className="max-w-7xl mx-auto px-6 py-10 pb-20">

      {/* ── Section Heading ── */}
      <div className="flex items-center gap-2 mb-8">
        <h1 className="text-3xl font-bold text-gray-900">
          Proud Partners
        </h1>
      </div>

      {/* ── Partner Grid ── */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-10" style={{ marginTop: "5%" }}>
        {PARTNERS.map((partner) => (
          <PartnerCard key={partner.name} partner={partner} />
        ))}
      </div>

    </div>
  );
}
